import * as React from 'react';
import { useAppointmentContext } from '../pages/BookAppointment/context/AppointmentContext.js';
import '@swc/helpers';
import '@grandvisionhq/graphql';
import '@grandvisionhq/state';
import '@grandvisionhq/utils';
import '../pages/BookAppointment/queries/get-book-appointment-store-by-id.js';
import '../pages/BookAppointment/queries/get-book-appointment-type.js';
import '@grandvisionhq/bloomreach';
import useVirtualAppointment from '../pages/BookAppointment/hooks/use-virtual-appointment.js';

const useDataLayerInput = ()=>{
    const [{ isVirtualAppointmentType  }] = useVirtualAppointment();
    const [, { timeSlot , type , store  }] = useAppointmentContext();
    return React.useMemo(()=>{
        return {
            store: store && !isVirtualAppointmentType(type) ? store : undefined,
            appointment: type ? {
                appointmentType: {
                    id: type.id,
                    isVirtualAppointment: isVirtualAppointmentType(type),
                    ageGroup: type.ageGroup
                },
                startTime: timeSlot === null || timeSlot === void 0 ? void 0 : timeSlot.from,
                endTime: timeSlot === null || timeSlot === void 0 ? void 0 : timeSlot.until
            } : undefined
        };
    }, [
        isVirtualAppointmentType,
        store,
        timeSlot === null || timeSlot === void 0 ? void 0 : timeSlot.from,
        timeSlot === null || timeSlot === void 0 ? void 0 : timeSlot.until,
        type
    ]);
};

export { useDataLayerInput as default };
//# sourceMappingURL=use-data-layer-input.js.map
